var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9541 89.9987H19.1157C16.8428 89.9987 15 88.1561 15 85.883C15 72.8072 25.5999 62.207 38.6758 62.207H60.3942C73.4699 62.207 84.07 72.807 84.07 85.883C84.0698 88.1561 82.2272 89.9987 79.9541 89.9987Z",
    fill: "url(#paint0_linear_6139_144060)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.394 62.207H41.2696V89.9987H79.9541C82.227 89.9987 84.0698 88.1561 84.0698 85.883C84.0698 72.8072 73.4699 62.207 60.394 62.207Z",
    fill: "url(#paint1_linear_6139_144060)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3941 62.207H38.6758C37.9592 62.207 37.2505 62.2407 36.5501 62.3032L64.2455 89.9987H79.9543C82.2272 89.9987 84.07 88.1561 84.07 85.883C84.0698 72.8072 73.4699 62.207 60.3941 62.207Z",
    fill: "url(#paint2_linear_6139_144060)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 85.8835C15 88.1566 16.8426 89.9992 19.1157 89.9992H79.9543C82.2272 89.9992 84.07 88.1566 84.07 85.8835C84.07 78.6041 80.7838 72.0931 75.6152 67.75H23.4548C18.2861 72.0931 15 78.6041 15 85.8835Z",
    fill: "url(#paint3_linear_6139_144060)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5349 10C34.1689 10 21.7115 22.4573 21.7115 37.8236C21.7115 53.1899 34.1689 65.647 49.5349 65.647C64.901 65.647 77.3583 53.1897 77.3583 37.8234C77.3583 22.4571 64.901 10 49.5349 10Z",
    fill: "#B1C3FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6096 14.4336L26.1466 52.8969C31.1009 60.5674 39.7247 65.6457 49.535 65.6457C64.901 65.6457 77.3583 53.1884 77.3583 37.8221C77.3583 28.0118 72.2801 19.3877 64.6096 14.4336Z",
    fill: "url(#paint4_linear_6139_144060)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6139_144060",
    x1: 54.3227,
    y1: 93.5873,
    x2: 42.5001,
    y2: 57.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#6796FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#D8DAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6139_144060",
    x1: 65.3326,
    y1: 75.7642,
    x2: 82.7713,
    y2: 74.4926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#ACD5FA",
    stopOpacity: 0.244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#9AC5F0",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#7CACDF",
    stopOpacity: 0.993
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6139_144060",
    x1: 72.5997,
    y1: 80.7977,
    x2: 46.5164,
    y2: 59.4669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#6796FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#D8DAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6139_144060",
    x1: 54.3227,
    y1: 92.8721,
    x2: 46.4732,
    y2: 62.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#6796FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#D8DAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6139_144060",
    x1: 55.3023,
    y1: 72.2584,
    x2: 19.2029,
    y2: 27.8284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#6796FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#D8DAFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyUser);
export default __webpack_public_path__ + "static/media/emptyUser.ba4811a5a4abdfc97c261f2ed7202f6c.svg";
export { ForwardRef as ReactComponent };